// extracted by mini-css-extract-plugin
export default {"card":"card_card__PaBHq","hoverLeft":"card_hoverLeft__EGeUG","hoverBottom":"card_hoverBottom__ahMTM"};